export const zipCodeRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;

export const phoneNumberInternationalRegExp = /^(\+)?[0-9]{7,20}$/;
/**
 * Allows empty strings
 * Only allows letters from all languages and digits.
 * Does not allow spaces or special characters.
 */
export const unicodeAlphaNumericOrEmptyRegExp = /^[\p{L}\p{N}]*$/iu;

/**
 * Accepts positive integers and decimals
 * e.g. 42, 0.005, 14.36
 */
export const positiveNumericRegExp = /^([0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/iu;
